import React, { createContext, useState } from "react"

export const loadingContext = createContext<{isPageFetched: any, setIsPageFetched: React.Dispatch<any>}>({
	isPageFetched: "loading",
  setIsPageFetched: () => {},
})

export function LoadingContextProvider({ children }: { children: React.ReactNode }) {
  const [isPageFetched, setIsPageFetched] = useState<string>("loading");

	return (
		<loadingContext.Provider value={{ isPageFetched, setIsPageFetched }}>
			{children}
		</loadingContext.Provider>
	)
}